<ion-grid class="team">
    <ion-row class="header">
        <ion-col size="1" size-lg="1"></ion-col>
        <ion-col [size]="area?.hideColumnsOnTable && hideAttributesFromUserSearchOn360 ? '5' 
                        : area?.hideColumnsOnTable ? '5'
                        : hideAttributesFromUserSearchOn360 ? '4'
                        : '2.3'">
            {{ 'generic.evaluee' | translate }}
        </ion-col>
        <ion-col *ngIf="!hideAttributesFromUserSearchOn360" [size]="area?.hideColumnsOnTable ? '3' : '1.5'">
            {{ 'generic.rank' | translate }}
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable && !hideAttributesFromUserSearchOn360" size="1.5" size-lg="1.5">
            {{ 'generic.area' | translate }}
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable" [size]="hideAttributesFromUserSearchOn360 ? '1.7' : '1.5'">
            {{ 'generic.lineManager' | translate }}
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable" size="1.2" size-lg="1.2">
            <div *ngIf="disableRelationColumn == null || !processConfig?.disableRelationColumn">
                {{ 'generic.relationship' | translate }}
            </div>
        </ion-col>
        <ion-col [size]="hideAttributesFromUserSearchOn360 ? '4' : '3'"></ion-col>
    </ion-row>

    <ion-row *ngFor="let user of users" class="users-list">
        <ion-col size="1" size-lg="1" size-xs="1">
            <img [src]="getImageUrl(user.imageUrl)" default="" class="avatar" />
        </ion-col>
        <ion-col [size]="area?.hideColumnsOnTable && hideAttributesFromUserSearchOn360 ? '5' 
                        : area?.hideColumnsOnTable ? '5'
                        : hideAttributesFromUserSearchOn360 ? '4'
                        : '2.3'">
            <h3>{{ user.name }}</h3>
        </ion-col>
        <ion-col *ngIf="!hideAttributesFromUserSearchOn360" [size]="area?.hideColumnsOnTable ? '3' : '1.5'">
            <h3>{{ user.attribute2 ? user.attribute2 : '-' }}</h3>
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable && !hideAttributesFromUserSearchOn360" size="1.5" size-lg="1.5">
            <h3>{{ user.attribute1 ? user.attribute1 : '-' }}</h3>
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable" [size]="hideAttributesFromUserSearchOn360 ? '1.7' : '1.5'">
            <h3>{{ user.lineManager ? user.lineManager : '-' }}</h3>
        </ion-col>
        <ion-col *ngIf="!area?.hideColumnsOnTable" size="1.2" size-lg="1.2">
            <div *ngIf="disableRelationColumn == null || !processConfig?.disableRelationColumn">
                <span *ngIf="!user.isManagerEvaluation">360</span>
                <span *ngIf="user.isManagerEvaluation">
                    {{ 'generic.manager' | translate }}
                </span>
                <ng-container *ngIf="haveAccessToChangeRelationship">
                    <ion-icon style="margin-left: 3px;" class="bp-edit"
                        (click)="confirmRelationshipChange(user)"></ion-icon>
                </ng-container>
            </div>
        </ion-col>
        <ion-col class="ion-flexed" [size]="hideAttributesFromUserSearchOn360 ? '4' : '3'">
            <ion-row class="button-actions">
                <div [ngSwitch]="user.status">
                    <ng-container *ngSwitchCase="ThreeSixtyEvaluationStatus.NotSent">
                        <ion-button class="ion-text-wrap open" mode="ios" expand="block" color="primary"
                            (click)="goToEvaluation.emit(user)">
                            {{ 'generic.evaluate' | translate }}
                        </ion-button>
                    </ng-container>
                    <ng-container *ngSwitchCase="ThreeSixtyEvaluationStatus.Sent">
                        <ion-button class="ion-text-wrap reopen" *ngIf="isAllowedToReopen" mode="ios" expand="block"
                            color="primary" (click)="reopenEvaluation(user)">
                            {{ 'processParticipants.reopen' | translate }}
                        </ion-button>
                        <ion-button class="ion-text-wrap" mode="ios" color="success" fill="clear" expand="block">
                            {{ 'generic.evaluated' | translate }}
                            <ion-icon slot="end" class="bp-check"></ion-icon>
                        </ion-button>
                        <ion-button (click)="goToEvaluation.emit(user)" [ngClass]="{
                                             'eye-margin': haveAccessToDelete && (!user.isManagerEvaluation || managerEvals.length > 1),
                                             'eye-margin-without-delete': !(haveAccessToDelete && (!user.isManagerEvaluation || managerEvals.length > 1))
                                           }" color="primary" fill="clear">
                            <ion-icon slot="icon-only" src="/assets/imgs/view.svg"></ion-icon>
                        </ion-button>
                        <ion-button *ngIf="haveAccessToDelete && (!user.isManagerEvaluation || managerEvals.length > 1)"
                            (click)="confirmDeleteEvaluation(user)" [ngClass]="{'delete-margin': user.status != 1}"
                            color="danger" fill="clear">
                            <ion-icon slot="icon-only" src="/assets/imgs/trash.svg"></ion-icon>
                        </ion-button>
                    </ng-container>
                </div>
            </ion-row>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="users?.length === 0">
        <ion-col size="12" class="no-evaluations-for-this-area">
            {{ getNoEvaluationAreaMessage() | translate }}
        </ion-col>
    </ion-row>
</ion-grid>